import {httpPost} from './base'
// tab1 订单运营数据
export const loadOrderUseRank = (page, pageSize, params) => { return httpPost('loudSpeakOperate/orderUse/' + page + '/' + pageSize, params).then(res => res) }
export const loadMysUseRank = (page, pageSize, params) => { return httpPost('loudSpeakOperate/mysUse/' + page + '/' + pageSize, params).then(res => res) }
export const loadUserUseRank = (page, pageSize, params) => { return httpPost('loudSpeakOperate/userUse/' + page + '/' + pageSize, params).then(res => res) }
export const loadOrdersSum = (params) => { return httpPost('loudSpeakOperate/ordersSum', params).then(res => res) }
export const loadModeOrders = (params) => { return httpPost('loudSpeakOperate/modeOrders', params).then(res => res) }

// tab2 用户运营数据
export const loadUserDetails = (params) => { return httpPost('loudSpeakOperate/userDetails', params).then(res => res) }
export const loadUserDataAnalyse = (params) => { return httpPost('loudSpeakOperate/userDataAnalyse', params).then(res => res) }



// WEBPACK FOOTER //
// ./src/api/loud-speak-operate.js